var map = {
	"./diet.jpg": 5553,
	"./diet.png": 7785,
	"./diet_1.png": 6041,
	"./intro.png": 9237,
	"./intro_2.png": 6182,
	"./time.png": 7816,
	"./tools.png": 1794,
	"./waste.png": 5293,
	"./waste_1.png": 9141
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6259;